/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';
import { Box, Grid } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import SegmentInfoCard from './segmentInfoCard.component';
import EstimateMovingDates from './estimateMovingDates.component';
import HhgAddressCard from './hhgAddressCard.component';
import CarShipmentVehiclesComponent from './carShipmentVehicles.component';
import { updateHhgEstimate } from 'modules/authorizations/store/actions/houseHoldGoods.actions';
import { SERVICE_IDS } from 'modules/enumerations/enumerationIds';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import AuthServiceGlobalEmailCardComponent from 'modules/emailTemplates/authEmailTemplates/authServiceGlobalEmailCard.component';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});

const PrimaryHhgInfo = props => {
  const {
    details,
    id,
    hHGServiceStatusTypes,
    vendors,
    segmentId,
    location,
    isReadOnly,
    history,
    authCommentRegardingTypes,
    authCommentServiceTypes,
    emailTemplates,
    enumerations
  } = props;

  const segmentInfo = details.hhgSegments ? details.hhgSegments.find(s => s.segmentInfo.hhgSegmentId === segmentId) : null;
  var vendorId = segmentInfo?.segmentInfo?.vendorId;
  let vendorOptions = [];
  if (vendorId) {
    const vendorIdSet = new Set([vendorId]);
    vendorOptions = Array.from(vendorIdSet)
      .map(vendorId => {
        const v = (vendors || []).find(x => x.vendorId === vendorId);
        if (!v?.officeEmail || !v?.companyName) return null;

        return {
          vendorId: vendorId,
          officeEmail: v.officeEmail,
          companyName: v.companyName
        };
      })
      .filter(Boolean);
  }
  const hhgSegmentTemplates = emailTemplates.filter(t => isIdEqual(t.serviceId, SERVICE_IDS.HHG_SERVICE_ID) && !t.containsHHG);

  return (
    <Box>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xl={8} rowSpacing={2} sx={{ marginTop: '-3px' }}></Grid>
        <Grid item xs={12} xl={8} rowSpacing={2}>
          <SegmentInfoCard
            segmentInfo={segmentInfo}
            storageAddress={segmentInfo ? segmentInfo.storageAddress : null}
            vendors={vendors}
            hideEdit={location.pathname.includes('expenses') || isReadOnly}
            id={id}
            isReadOnly={isReadOnly}
            enumerations={enumerations}
          />
          <Box sx={{ paddingTop: '16px' }}>
            <CarShipmentVehiclesComponent
              hhgSegmentVehicles={segmentInfo.vehicles}
              segmentId={segmentId}
              authorizationId={id}
              isReadOnly={isReadOnly}
              segmentInfo={segmentInfo}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <EstimateMovingDates segmentInfo={segmentInfo} hideEdit={isReadOnly} id={id} hHGServiceStatusTypes={hHGServiceStatusTypes} />
          </Box>
        </Grid>
        <Grid item xs={12} xl={4} rowSpacing={2}>
          <AuthServiceGlobalEmailCardComponent
            authId={id}
            communication={details.authorizationDetails}
            serviceTemplates={hhgSegmentTemplates}
            serviceId={SERVICE_IDS.HHG_SERVICE_ID}
            authCommentServicesEnum={authCommentServiceTypes}
            authCommentRegardingEnum={authCommentRegardingTypes}
            authSentTemplates={details.sentEmailTemplates}
            history={history}
            selectedAuthServiceId={segmentId}
            vendorOptions={vendorOptions}
            allVendorOptions={vendors}
            emailTemplates={emailTemplates}
            selectedSegmentServiceId={segmentId}
            selectedVendorId={vendorId}
          />
          <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '16px' }}>
            <HhgAddressCard
              segmentInfo={segmentInfo.segmentInfo}
              storageAddress={segmentInfo.storageAddress}
              hideEdit={location.pathname.includes('expenses') || isReadOnly}
              id={id}
              addresses={details.addresses}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

PrimaryHhgInfo.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {};
};

export default compose(withStyles(styles), connect(mapStateToProps, { updateHhgEstimate }))(PrimaryHhgInfo);
